import { render, staticRenderFns } from "./EmptyCompras.vue?vue&type=template&id=3b72be8b"
import script from "./EmptyCompras.vue?vue&type=script&lang=js"
export * from "./EmptyCompras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports